import(/* webpackMode: "eager" */ "/app/apps/web-tms/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/web-tms/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NetworkStatusWrapper"] */ "/app/apps/web-tms/src/components/network-status-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PWAWrapper"] */ "/app/apps/web-tms/src/components/pwa-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegistration"] */ "/app/apps/web-tms/src/components/service-worker-registration.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web-tms/src/components/toaster-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DxLocaleProvider"] */ "/app/apps/web-tms/src/providers/dx-locale-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.8.2_@swc+helpers@0.5.18_next@16.1.6_@babel+core@7.29.0_@opentelemetry+api@1_bd3a19d1ad5f6df2a56ad0158ddbe908/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/index.ts");
